import { render, staticRenderFns } from "./TmetricFields.vue?vue&type=template&id=540a19da&"
import script from "./TmetricFields.vue?vue&type=script&lang=js&"
export * from "./TmetricFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports